export const QUERY_PRODUCT_DETAIL = `query productDetail($productId: ID!) {
  product(productId: $productId) {
          id
          description
          articleNumber
          customer
          screwType
          head
          screwDiameter
          screwLength
          recessType
          surfaceColor
          threadType
          customerArticleNumber
          customerProductDescription
                    productGroup {
            id
            name
          }
    templates {
      id
      name
      productTemplateCharacteristics {
        id
        shortcut
        value1
        value2
        order
      }
    }
    properties {
      stringValue {
        id
        propertyType
        value
      }
      singleValue {
        id
        propertyType
        name
      }
      multpileValues {
        propertyType
        id
        values {
          id
          propertyType
          name
        }
      }
    }
  }
}`
